import React from "react";

export function SectionCard({ title, icon: Icon, desc, children, testId, actions }) {
  return (
    <div className="hah-card p-5" data-testid={testId}>
      <div className="flex items-start justify-between gap-3 mb-3">
        <div>
          <h3 className="text-base font-semibold text-[#1F2937] flex items-center gap-2">
            {Icon && <Icon className="w-4 h-4 text-[#0B7E8C]" />} {title}
          </h3>
          {desc && <p className="text-xs text-[#6B7280] mt-0.5">{desc}</p>}
        </div>
        {actions}
      </div>
      {children}
    </div>
  );
}

export function Field({ label, children, hint, full }) {
  return (
    <div className={full ? "md:col-span-2" : ""}>
      {label && <label className="block text-[11px] uppercase tracking-wider font-semibold text-[#6B7280] mb-1.5">{label}</label>}
      {children}
      {hint && <p className="text-[11px] text-[#94A3B8] mt-1">{hint}</p>}
    </div>
  );
}

/** Generic chip multi-select. options: [{value,label}]. value: string[] */
export function ChipMultiSelect({ options, value = [], onChange, disabled, testIdPrefix = "chip" }) {
  const toggle = (v) => {
    if (disabled) return;
    onChange(value.includes(v) ? value.filter((x) => x !== v) : [...value, v]);
  };
  return (
    <div className="flex flex-wrap gap-1.5">
      {options.map((o) => {
        const active = value.includes(o.value);
        return (
          <button
            key={o.value}
            type="button"
            disabled={disabled}
            onClick={() => toggle(o.value)}
            data-testid={`${testIdPrefix}-${o.value}`}
            className={`text-xs px-2.5 py-1.5 rounded-full border transition-colors ${
              active
                ? "bg-[#0B7E8C] text-white border-[#0B7E8C]"
                : "bg-white text-[#475569] border-[#E5E7EB] hover:border-[#0B7E8C] hover:text-[#0B7E8C]"
            } ${disabled ? "opacity-60 cursor-not-allowed" : ""}`}
          >
            {o.label}
          </button>
        );
      })}
    </div>
  );
}

export const toOpts = (arr) => (arr || []).map((s) => ({ value: s, label: s }));
